import { createBrowserRouter } from 'react-router';
import routes from './routes';

const router = createBrowserRouter(routes);

export default router;
